$(document).on('turbo:load', () => {


  $('#profile-phone-number-field').on('keyup', (event) => {
    var value = $(event.target).val();
  
    // if input value is falsy eg if the user deletes the input, then just return
    if (!value) return value;

    // clean the input for any non-digit values.
    const phoneNumber = value.replace(/[^\d]/g, "");

    // phoneNumberLength is used to know when to apply our formatting for the phone number
    const phoneNumberLength = phoneNumber.length;

    // we need to return the value with no formatting if its less then four digits
    // this is to avoid weird behavior that occurs if you  format the area code to early
    if (phoneNumberLength < 4) return phoneNumber;

    // if phoneNumberLength is greater than 4 and less the 7 we start to return
    // the formatted number
    var formattedVal;
    if (phoneNumberLength < 7) {
      formattedVal = `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    } else {
      // finally, if the phoneNumberLength is greater then seven, we add the last
      // bit of formatting and return it.
      formattedVal = `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
    }

    $(event.target).val(formattedVal);
  });

  $('#household-income-input').on("keyup", (event) => {
    var val = $('#household-income-input').val().replaceAll(",", "");
    val = Number(val).toLocaleString();
    $('#household-income-input').val(val);
  });
});